import Api from './api';

const EducacaoService = {
    cadastroDocumentos: async (params) => {
        const response = await Api.post('/restrito/doceducacao/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listarDocumentos: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/doceducacao/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarDocumentos: (id) => {
        Api.delete(`/restrito/doceducacao/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    educEditDocumentos: async (id) => {
        const response = await Api.get(`/restrito/doceducacao/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarDocumentos: async (id, params) => {
        const response = await Api.put(`/restrito/doceducacao/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarDocumentos: (params) => {
        const response = Api.get(`/restrito/doceducacao/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default EducacaoService;